/**
 * authProvider.js
 * Handles authentication via the SmartLeadAI API using native fetch
 */

import API_URL from './config';

const authProvider = {
  login: async ({ username, password }) => {
    // Native fetch to ensure headers are correctly applied
    const response = await fetch(`${API_URL}/auth/login/`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: username, password }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      
      // Handle rate limiting (PT2287-10)
      if (response.status === 429) {
        const message = errorData.detail || 'Zbyt wiele prób logowania. Spróbuj ponownie później.';
        throw new Error(message);
      }
      
      const message = errorData.detail || 'Login failed';
      throw new Error(message);
    }

    const { access, refresh } = await response.json();
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);

    // 2) Immediately fetch "my-account" to grab user details
    try {
      const meRes = await fetch(`${API_URL}/my-account/`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${access}`,
        },
      });
      
      if (meRes.ok) {
        const meData = await meRes.json();
        localStorage.setItem('user_id', meData.id);
        localStorage.setItem('user_first_name', meData.first_name);
        localStorage.setItem('user_last_name', meData.last_name);
        localStorage.setItem('user_role', meData.role);
      }
    } catch (e) {
      // Silently handle error
    }

    return Promise.resolve();
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_first_name');
    localStorage.removeItem('user_last_name');
    localStorage.removeItem('user_role');
    return Promise.resolve();
  },

  checkAuth: () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      return Promise.reject({ redirectTo: '/login' });
    }
    return Promise.resolve();
  },

  checkError: (error) => {
    if (!error) return Promise.resolve();
    
    const status = error.status;
    const message = error.message;

    if (status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_first_name');
      localStorage.removeItem('user_last_name');
      localStorage.removeItem('user_role');
      return Promise.reject({ redirectTo: '/login' });
    }
    
    if (status === 403) {
      return Promise.reject({ redirectTo: '/tenders' });
    }
    
    // Handle rate limiting (PT2287-10)
    if (status === 429) {
      return Promise.reject({ 
        message: message || 'Zbyt wiele prób. Spróbuj ponownie później.',
        logoutUser: false 
      });
    }

    return Promise.resolve();
  },

  getPermissions: () => {
    const role = localStorage.getItem('user_role');
    return Promise.resolve(role);
  },
};

export default authProvider;